import service from "@irati/utils/tracking/index"

const tracking = {
  popupShown: () => {
    service.trackPlatformEvent("mfa_popup_shown", {})
  },
  popupCancel: () => {
    service.trackPlatformEvent("mfa_popup_cancel", {})
  },
  popupRequestCode: () => {
    service.trackPlatformEvent("mfa_popup_requestCode", {})
  },
  popupComplete: () => {
    service.trackPlatformEvent("mfa_popup_complete", {})
  },
  popupSetupShown: () => {
    service.trackPlatformEvent("mfa_popup_setup_shown", {})
  },
  popupSetupCancel: () => {
    service.trackPlatformEvent("mfa_popup_setup_cancel", {})
  },
  popupSetupComplete: () => {
    service.trackPlatformEvent("mfa_popup_setup_complete", {})
  }
}

export default tracking
